function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(90 39 39.3)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  opacity: 0.4,
  cx: 38.88,
  cy: 38.88,
  r: 38.88
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 38.88,
  cy: 38.88,
  r: 28.08
}), /*#__PURE__*/React.createElement("path", {
  fill: "red",
  fillRule: "nonzero",
  d: "M35.64 47.943l.94.939 9.86-9.861-9.86-9.861-.94.94 8.922 8.92z"
}));

var SvgFlechadown = function SvgFlechadown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 79"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgdmlld0JveD0iMCAwIDc5IDc5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNjIgKDkxMzkwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4NCiAgICA8dGl0bGU+ZmxlY2hhPC90aXRsZT4NCiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4NCiAgICA8ZyBpZD0iUHJlc2VudGFjaW9uIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9ImludGVyZmF6MDVfZW5lcmdpYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExNjEuMDAwMDAwLCAtNDY5LjAwMDAwMCkiPg0KICAgICAgICAgICAgPGcgaWQ9Im1hcmNhZG9yZXMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjEuMDAwMDAwLCAzODEuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPGcgaWQ9ImZsZWNoYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzkuMzAwMDAwLCAxMjcuMzAwMDAwKSByb3RhdGUoLTI3MC4wMDAwMDApIHRyYW5zbGF0ZSgtMzkuMzAwMDAwLCAtMTI3LjMwMDAwMCkgdHJhbnNsYXRlKDAuMzAwMDAwLCA4OC4zMDAwMDApIj4NCiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0ZGRkZGRiIgb3BhY2l0eT0iMC40IiBjeD0iMzguODgiIGN5PSIzOC44OCIgcj0iMzguODgiPjwvY2lyY2xlPg0KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjRkZGRkZGIiBjeD0iMzguODgiIGN5PSIzOC44OCIgcj0iMjguMDgiPjwvY2lyY2xlPg0KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iI0ZGMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNi41NzkxMzAsIDM5LjAyMDg3MCkgcm90YXRlKC0xMzUuMDAwMDAwKSB0cmFuc2xhdGUoLTM2LjU3OTEzMCwgLTM5LjAyMDg3MCkgIiBwb2ludHM9IjMwLjkzNDU3MzcgMzIuMDQ4MTgxOCAyOS42MDY0NDI3IDMyLjA0ODE4MTggMjkuNjA2NDQyNyA0NS45OTM1NTczIDQzLjU1MTgxODIgNDUuOTkzNTU3MyA0My41NTE4MTgyIDQ0LjY2NTQyNjMgMzAuOTM0NTczNyA0NC42NjU0MjYzIj48L3BvbHlnb24+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+";
export { SvgFlechadown as ReactComponent };